import React from 'react'
import './AboutMe.css'
import SectionIds from '../../Helper/SectionId'
import goToLink from '../../Helper/GoToLink'
import GoToLinks from '../../Data/GoToLinks'
import AssetImage from '../../Helper/AssetImage'
import AssetImages from '../../Helper/AssetImages'
import SectionWithAnalytics from '../../Components/sectionWithAnalytics'

export default function AboutMe() {
    return (
        <SectionWithAnalytics className='section section-aboutme res-gap-32' id={SectionIds.sectionAboutMe} >

            <AssetImage assetImage={AssetImages.imageAboutMe} />

            <main className='container-vertical res-gap-32'>
                <div className="header container-vertical res-gap-8 ">
                    <div className='fs-medium fw-semibold clr-primary text-align-left '>
                        About Me
                    </div>
                    <h3 className='text-align-left'>
                        I am 
                        <mark>
                            Sachin Anpat
                        </mark> , 
                        <br /> Stock Broker associated with
                        
                        <a 
                        onClick={()=>goToLink(GoToLinks.globeWebsite)} 
                        className='highlight'>
                            Globe Capital
                        </a>
                    </h3>
                </div>
                <p className='fs-medium fw-regular .clr-grey-600'>
                    Started as a trader in 2010 with developing research skills & Experience of Risk management, Learning Trading Style & Strategies, with creating a business plan.
                    <br /><br />
                    I am very passionate about my work in finance & investment field. As in growing era of opportunities would like to enhance your Trading and Investement Skills
                    <br /><br />
                    As a Broker, would like to work with the end customers, with a good analaytical thinking and fundamental skills. Like to ANALYZE / GROW your financial and investment skills.
                </p>
            </main>
        </SectionWithAnalytics>
    )
}
